module.exports = __webpack_public_path__ + "static/media/197.d2abdc98.jpg";